import range from 'lodash/range';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  height: 150px;
  width: 400px;
`;

const Charity = props => (
  <StyledContentLoader
    speed={2}
    width={400}
    height={150}
    viewBox="0 0 400 150"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="95" y="9" rx="3" ry="3" width="180" height="6" />
    <rect x="95" y="40" rx="3" ry="3" width="52" height="6" />
    <rect x="95" y="28" rx="3" ry="3" width="180" height="6" />
    <rect x="95" y="65" rx="3" ry="3" width="70" height="12" />
    <rect x="0" y="0" rx="6" ry="6" width="80" height="87" />
  </StyledContentLoader>
);

const CharityLoader = ({ count = 12 }) => range(count).map(item => <Charity key={item} />);

export default CharityLoader;
